export enum BoosterTypeEnum {
  LEVEL = 'level_booster',
  MISSION = 'mission_booster',
  TOKEN = 'token_booster',
}
